export default __webpack_public_path__ + "static/media/weare.5f0cd241.png";